import MuiTooltip, {
    type TooltipProps as MuiTooltipProps,
    tooltipClasses,
} from '@mui/material/Tooltip';
import { type ElementType } from 'react';
import { styled } from '../../theme';
import { Box, type BoxProps } from '../Box';

export interface TooltipProps extends MuiTooltipProps {
    component?: ElementType;
    display?: BoxProps['display'];
    tooltipTheme?: 'light' | 'dark';
}

export const Tooltip = ({
    disableInteractive = true,
    component,
    display = 'inline',
    ...props
}: TooltipProps) => (
    <StyledMuiTooltip {...props} disableInteractive={disableInteractive}>
        <Box component={component} display={display}>
            {props.children}
        </Box>
    </StyledMuiTooltip>
);

const StyledMuiTooltip = styled(
    ({ className, ...props }: TooltipProps) => (
        <MuiTooltip {...props} classes={{ popper: className }} />
    ),
    { shouldForwardProp: (propName) => propName !== 'tooltipTheme' },
)(({ tooltipTheme, theme }) => ({
    [`& a`]: {
        color: theme.colors.text.inverse,
        [`&:hover`]: {
            color: theme.colors.text.inverse,
        },
    },
    [`& .${tooltipClasses.tooltip}`]:
        tooltipTheme === 'light'
            ? {
                  backgroundColor: theme.colors.background.default,
                  color: theme.palette.text.primary,
              }
            : {},
}));
